import { lumappsJourney } from '@lumapps/lumx/custom-icons';
import { mdiNewspaperVariantOutline, mdiPlay } from '@lumapps/lumx/icons';
import { NavigationItemType } from '@lumapps/navigation/types';
import { PLAY } from '@lumapps/play/keys';

import { NAVIGATION_ADMIN } from './keys';

/** a string prefix for a new node id to indicate it's a temp id before saving */
export const NODE_TEMP_ID_PREFIX = 'temp-';

/** the navigation admin scope name for data-attribute */
export const SCOPE = 'navigation-admin';

export type PickerTypes =
    | NavigationItemType.CONTENT
    | NavigationItemType.CUSTOM_LIST
    | NavigationItemType.DIRECTORY
    | NavigationItemType.USER_DIRECTORY
    | NavigationItemType.COMMUNITY
    | NavigationItemType.ARTICLE;

/** Type-specific data to show for the SystemPagesNavigationItemDetails GenericEntityBlock */
export const SYSTEM_PAGES_NAV_ITEM_DETAILS = {
    journeys: {
        title: NAVIGATION_ADMIN.JOURNEY,
        icon: lumappsJourney,
    },
    personal_feed: {
        title: NAVIGATION_ADMIN.PERSONAL_FEED,
        icon: mdiNewspaperVariantOutline,
    },
    video_gallery: {
        title: PLAY.VIDEO_GALLERY_TITLE,
        icon: mdiPlay,
    },
};
